import { render, staticRenderFns } from "./AssessmentsWidget.vue?vue&type=template&id=54562306&scoped=true&"
import script from "./AssessmentsWidget.vue?vue&type=script&lang=js&"
export * from "./AssessmentsWidget.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentsWidget.vue?vue&type=style&index=0&id=54562306&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54562306",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCol,VContainer,VRow,VSheet})
